import RestrictedIcon from '@/assets/restricted.svg?react'
import { useTranslation } from 'react-i18next'

export default function NoAccess() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-8">
      <RestrictedIcon className="w-32 h-32" />
      <h1 className="text-2xl font-semibold mb-2 text-text-secondary">{t('noAccess.title')}</h1>
      <p className="text-text-secondary">{t('noAccess.description')}</p>
    </div>
  )
}
